module.exports = __webpack_public_path__ + "media/dog-profile-avatars/single-great-dane-34e98b6b.svg";